<template>
  <nav>
    <div class="hidden-md-and-up">
      <MenuButton :is-open="isOpen" type="mobile" @onClick="handleToggle" />
      <Menu :is-open="isOpen" type="mobile" />
    </div>
    <div class="hidden-sm-and-down pc-nav">
      <MenuButton :is-open="isOpen" type="desktop" @onClick="handleToggle" />
      <div class="pc-nav__menu">
        <a href="https://www.omygod.com.tw/supermall/super">
          <img :src="OmyGodShopButton">
        </a>
        <router-link to="/">
          <a href="https://www.hope-coop.org/">
            <img :src="LogoButton">
          </a>
        </router-link>
        <router-link to="/contact-us">
          <img :src="ContactButton">
        </router-link>
      </div>
      <Menu :is-open="isOpen" type="desktop" />
    </div>
  </nav>
</template>

<script>
import LogoButton from '@/assets/img/btn_logo.png'
import ShopButton from '@/assets/img/btn_shop.png'
import OmyGodShopButton from '@/assets/img/btn_omygod_shop.jpg'
import ContactButton from '@/assets/img/btn_contact.png'
import MenuButton from './MenuButton.vue'
import Menu from './Menu.vue'
export default {
  components: {
    MenuButton,
    Menu
  },
  data() {
    return {
      LogoButton,
      OmyGodShopButton,
      ShopButton,
      ContactButton,
      isOpen: false
    }
  },
  watch: {
    $route() {
      this.isOpen = false
    }
  },
  methods: {
    handleToggle() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>

nav {
  @include minWidth992 {
    width: 100px;
    position: fixed;
    z-index: 10;
    padding: 20px;
    right: 0px;
    height: 100vh;
    background-color: #fff;
  }
}

.pc-nav {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  a {
    display: flex;
    margin-bottom: 20px;
  }
}

</style>
